import {getLoginToken, getSelectedProject} from './common.js'
import {api_host} from '../config/config.js'
// const request = require('request')

const request_get = (path) => {
    return new Promise((resolve, reject)=>{
        var token = getLoginToken();
        var header = { 'Content-Type': 'application/json'};
        if(token)
            header['x-access-token'] = token;
        let devil_project = getSelectedProject()
        if(devil_project)
            header['devil_project'] = '' +devil_project;
        const request = new Request(`${api_host}${path}`, {
            method: 'GET',
            headers: new Headers(header),
        })
        fetch(request)
            .then(response => {
                if (response.status < 200 || response.status >= 300) {
                    reject(response);
                }
                else resolve(response.json());
            });
    })
}

const request_post = (path, param) => {
    return new Promise((resolve, reject)=>{
        var token = getLoginToken();
        var header = { 'Content-Type': 'application/json'};
        if(token)
            header['x-access-token'] = token;
        let devil_project = getSelectedProject()
        if(devil_project)
            header['devil_project'] = '' +devil_project;
        const request = new Request(`${api_host}${path}`, {
            method: 'POST',
            body: JSON.stringify(param),
            headers: new Headers(header),
        })
        fetch(request)
            .then(response => {
                if (response.status < 200 || response.status >= 300) {
                    reject(response);
                } else
                    resolve(response.json());
            });
    })
    
}

const request_put = async (path, param) => {
    var token = getLoginToken();
    var header = { 'Content-Type': 'application/json'};
    if(token)
        header['x-access-token'] = token;
    let devil_project = getSelectedProject()
    if(devil_project)
        header['devil_project'] = '' +devil_project;
    const request = new Request(`${api_host}${path}`, {
        method: 'PUT',
        body: JSON.stringify(param),
        headers: new Headers(header),
    })
    return fetch(request)
        .then(response => {
            if (response.status < 200 || response.status >= 300) {
                ;//throw new Error(response.statusText);
            }
            return response.json();
        });
}

const request_delete = async (path, param) => {
    var token = getLoginToken();
    var header = { 'Content-Type': 'application/json'};
    if(token)
        header['x-access-token'] = token;
    let devil_project = getSelectedProject()
    if(devil_project)
        header['devil_project'] = '' +devil_project;
    const request = new Request(`${api_host}${path}`, {
        method: 'DELETE',
        body: JSON.stringify(param),
        headers: new Headers(header),
    })
    return fetch(request)
        .then(response => {
            if (response.status < 200 || response.status >= 300) {
                ;//throw new Error(response.statusText);
            }
            return response.json();
        });
}
export default {
    request_get,
    request_post,
    request_put,
    request_delete,
};